import React, { Component } from 'react';
import { PrismicDocumentHelper } from '../../../../../../helpers/prismicHelpers/PrismicHelpers';
import { seriesHelper, podcastPageHelper } from '../../../../../../helpers/prismicHelpers/prismic-custom-helpers/PodcastHelper';
import PodcastSeriesList from './elements/PodcastSeriesList';
import ThemePageBanner from "../../../../../dashboardNew/components/ThemePageBanner";
import Anchor from "../../../../../dashboardNew/objects/Anchor";

class PodcastSeriesPage extends Component {
    constructor() {
        super();
        this.state = {
            series: '',
            podcastInfo: ''
        }
    }

    componentWillMount() {
        this.getSeries();
        this.getSeriesInfo();
    }

    async getSeries() {
        const data = await PrismicDocumentHelper('document.type', 'series-podcast', false, 'at')
        const series = seriesHelper(data);
        this.setState({ series })
    }
    //Used to get data for banner title and summary
    async getSeriesInfo() {
        const data = await PrismicDocumentHelper('document.type', 'podcast-page', false, 'at')
        const podcastInfo = podcastPageHelper(data);
        this.setState({ podcastInfo })
    }

    render() {

        const podcast = this.state.podcastInfo && this.state.podcastInfo[0];

        return (
            <React.Fragment>
                {
                    podcast &&
                    <ThemePageBanner image='/images/podcast.jpg' heading={podcast.podcast_title} />
                }
                <div className="container theme-page-content-wrapper">
                    <div className="row">
                        <div className="col-12 heading-section no-margin">
                            <p className="body-copy">{podcast.podcast_summary}</p>
                        </div>
                        <div className="row">
                            <div className="col-12 body-section">
                                {podcast && <PodcastSeriesList series={this.state.series} />}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default PodcastSeriesPage


// WEBPACK FOOTER //
// src/client/components/site/features/training/podcasts/series/PodcastSeriesPage.js